import requests from "../agent";

const Shipment = {
  getAll: (filter) => requests.post("/Envio/GetAll", filter),
  getById: (id) => requests.get(`/Envio/GetById/${id}`),
  downloadGuide: (id, name) => requests.download(`/Envio/DownloadGuide/${id}`, name),
  getGuideFile: (id) => requests.postFileBlob(`/Envio/DownloadGuide/${id}`, null),
  exporterExcel: (filter, name) =>
    requests.download("/Envio/ExporterByFilter", name, filter),

  getExistGuium: (noGuium, lockGuium) => requests.get(`/Envio/GetExistGuium/${noGuium}/${lockGuium}`),
  receivedGuium: (guium) => requests.post("Envio/ReceivedGuium", guium),
  createdGuium: (guium) => requests.post("Envio/CreateGuium", guium),
  updateGuium: (guium) => requests.put("Envio/UpdateGuium", guium),

  getGuide: (id, idOrganization) => requests.get(`/EnvioAnonymous/GetGuide/${id}/${idOrganization}`),

  getMovimientosToday: () => requests.get(`/Envio/GetMovimientosToday`),
  revisonMovimientoUsuario: (data) => requests.post(`/Envio/RevisonMovimientoUsuario`, data),
  leerAlertasUsuario: (data) => requests.post(`/Envio/LeerAlertasUsuario`, data),
  cerrarAlertasUsuario: (data) => requests.post(`/Envio/CerrarAlertasUsuario`, data),
  consultarEnviosParaEmbarque: (data) => requests.post(`/Envio/ConsultarEnviosParaEmbarque`, data),
  bloqueoEnvio: (bloqueo, data) => requests.patch(`/Envio/BloqueoEnvio/${bloqueo}`, data),
  notificarEnvioActualizado: (data) => requests.post(`/Envio/NotificarEnvioActualizado`, data),  

  getMovimientosProveedor: () => requests.get(`/Envio/GetMovimientosProveedor`),
  getEnviosProgramadosRevision: () => requests.get(`/Envio/GetEnviosProgramadosRevision`),
  revisoEnviosProgramados: (data) => requests.post(`/Envio/RevisoEnviosProgramados`, data)
};

export default Shipment;
